import { useTranslation } from 'react-i18next'
import { useTheme } from '../lib/theme'

/**
 * Subtle theme toggle. Sun in light mode, moon in dark; one click flips
 * and the choice persists. Deliberately unobtrusive — no label, small
 * hit area, muted colours — since most users will leave the default (OS
 * preference) alone. Positioning is owned by the parent container so the
 * toggle can sit in the floating preferences bar alongside the language
 * picker.
 */
export function ThemeToggle() {
  const { resolved, toggle } = useTheme()
  const { t } = useTranslation()
  const isDark = resolved === 'dark'
  const label = isDark ? t('nav.themeLight') : t('nav.themeDark')
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-stone-200 bg-white/80 text-stone-500 shadow-sm backdrop-blur transition hover:text-stone-900 focus:outline-none focus:ring-2 focus:ring-emerald-700/40 dark:border-stone-700 dark:bg-stone-900/80 dark:text-stone-400 dark:hover:text-stone-100"
    >
      {isDark ? <SunIcon /> : <MoonIcon />}
    </button>
  )
}

function SunIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-4 w-4"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  )
}

function MoonIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-4 w-4"
      aria-hidden="true"
    >
      <path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z" />
    </svg>
  )
}
